import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiLock, FiMail, FiRefreshCw } from 'react-icons/fi';
import platformLogo from '../../assets/images/M_Multicolor.svg';
const PlatformMark: React.FC<{
    size?: number;
}> = ({ size = 36 }) => (<div style={{
        width: size, height: size,
        borderRadius: Math.round(size * 0.29),
        background: 'linear-gradient(135deg, #1e1060 0%, #2d1b69 100%)',
        border: '1px solid rgba(139,92,246,0.28)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
    }}>
    <img src={platformLogo} alt="IAAI" style={{ width: size * 0.7, height: size * 0.7, objectFit: 'contain' }}/>
  </div>);
const ClaudeMark: React.FC<{
    size?: number;
}> = ({ size = 36 }) => (<svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="cl-bg-p" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#fb923c"/>
        <stop offset="100%" stopColor="#c2410c"/>
      </linearGradient>
    </defs>
    <rect width="48" height="48" rx="14" fill="url(#cl-bg-p)"/>
    <rect width="48" height="48" rx="14" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="1"/>
    <g transform="translate(24,24)">
      {([0, 45, 90, 135, 180, 225, 270, 315] as const).map(a => (<rect key={a} x="-2.8" y="-20" width="5.6" height="15" rx="2.8" fill="rgba(255,255,255,0.95)" transform={`rotate(${a})`}/>))}
    </g>
  </svg>);
const PendingHero: React.FC = () => (<div className="ca-ph-wrap">
    <div className="ca-ph-ring ca-ph-ring--1"/>
    <div className="ca-ph-ring ca-ph-ring--2"/>
    <div className="ca-ph-core">
      <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
        <g transform="translate(20,20)">
          {([0, 45, 90, 135, 180, 225, 270, 315] as const).map(a => (<rect key={a} x="-2.5" y="-17" width="5" height="12" rx="2.5" fill="#f97316" transform={`rotate(${a})`}/>))}
        </g>
      </svg>
    </div>
  </div>);
const STEPS = [
    { key: 'submitted', label: 'Submitted', state: 'done' as const, icon: <FiCheck size={11}/> },
    { key: 'review', label: 'In Review', state: 'active' as const, icon: <FiRefreshCw size={11} className="ca-lspin"/> },
    { key: 'approval', label: 'Approval', state: 'pending' as const, icon: <FiLock size={11}/> },
    { key: 'access', label: 'Access', state: 'pending' as const, icon: <FiMail size={11}/> },
];
const WHAT_NEXT = [
    { icon: <FiRefreshCw size={14}/>, title: 'Team is reviewing', desc: 'We check your agency profile and use case.' },
    { icon: <FiLock size={14}/>, title: 'Admin signs off', desc: 'A Momentum AMP admin approves the request.' },
    { icon: <FiMail size={14}/>, title: 'You get notified', desc: 'Email confirmation with access instructions.' },
];
const ClaudeAgentPendingPage: React.FC = () => (<div className="ca-landing">
    <motion.div className="ca-lcard" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.38, ease: [0.16, 1, 0.3, 1] }}>
      <div className="ca-lcard__glow"/>
      <div className="ca-lcard__glow ca-lcard__glow--purple"/>

      <div className="ca-partner-row" style={{ marginBottom: 6 }}>
        <PlatformMark size={36}/>
        <span className="ca-partner-x">×</span>
        <ClaudeMark size={36}/>
      </div>
      <div className="ca-partner-label">Momentum AMP × Anthropic Claude</div>

      <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.1, type: 'spring', stiffness: 260, damping: 22 }}>
        <PendingHero />
      </motion.div>

      <motion.div className="ca-pending-status" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
        <span className="ca-pending-status__dot"/>
        UNDER REVIEW
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.22 }}>
        <h2 className="ca-pending-title">Request Under Review</h2>
        <p className="ca-pending-desc">
          We've received your Claude Agents access request. Our team will review and approve it — usually within 1–2 business days.
        </p>
      </motion.div>

      <motion.div className="ca-stepper" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
        {STEPS.map((step, i) => (<React.Fragment key={step.key}>
            <div className={`ca-stepper-step ${step.state}`}>
              <div className="ca-stepper-dot">{step.icon}</div>
              <div className="ca-stepper-label">{step.label}</div>
            </div>
            {i < STEPS.length - 1 && (<div className={`ca-stepper-line ${i === 0 ? 'done' : 'pending'}`}/>)}
          </React.Fragment>))}
      </motion.div>

      <motion.div className="ca-pending-steps" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.38 }}>
        {WHAT_NEXT.map((item, i) => (<div key={i} className="ca-pending-step-card">
            <div className="ca-pending-step-num">{i + 1}</div>
            <div className="ca-pending-step-icon">{item.icon}</div>
            <div className="ca-pending-step-body">
              <div className="ca-pending-step-title">{item.title}</div>
              <div className="ca-pending-step-desc">{item.desc}</div>
            </div>
          </div>))}
      </motion.div>

      <motion.p className="ca-lnote" style={{ justifyContent: 'center', marginTop: 4 }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.45 }}>
        Questions? &nbsp;
        <span style={{ color: '#f97316' }}>support@momentumamp.com</span>
      </motion.p>
    </motion.div>
  </div>);
export default ClaudeAgentPendingPage;
